var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 22,
    viewBox: "0 0 29 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.35251 17.2107L3.72244 11.6441C3.57522 11.4967 3.39988 11.3798 3.20659 11.2999C3.0133 11.2201 2.80591 11.179 2.59643 11.179C2.38695 11.179 2.17955 11.2201 1.98627 11.2999C1.79298 11.3798 1.61764 11.4967 1.47042 11.6441C1.3214 11.7897 1.20308 11.963 1.12233 12.1541C1.04158 12.3452 1 12.5503 1 12.7574C1 12.9645 1.04158 13.1696 1.12233 13.3607C1.20308 13.5518 1.3214 13.7252 1.47042 13.8707L8.21041 20.5348C8.83776 21.1551 9.85117 21.1551 10.4785 20.5348L27.5296 3.69176C27.6786 3.5462 27.7969 3.37284 27.8777 3.18173C27.9584 2.99062 28 2.78556 28 2.57844C28 2.37132 27.9584 2.16626 27.8777 1.97515C27.7969 1.78404 27.6786 1.61068 27.5296 1.46511C27.3824 1.31777 27.207 1.20079 27.0137 1.12095C26.8204 1.04111 26.6131 1 26.4036 1C26.1941 1 25.9867 1.04111 25.7934 1.12095C25.6001 1.20079 25.4248 1.31777 25.2776 1.46511L9.35251 17.2107Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCk);
export default __webpack_public_path__ + "static/media/ck.c8aeaf72481b82f6173baa74ef0a5784.svg";
export { ForwardRef as ReactComponent };